import React from "react";
import "./TeamScore.css";

export default function TeamScore({ gotis }) {
  const aFinished = gotis.filter((g) => g.playerId % 2 === 0 && g.finished).length;
  const bFinished = gotis.filter((g) => g.playerId % 2 !== 0 && g.finished).length;

  return (
    <div className="teamScoreBar">
      <div className={`teamScoreSide teamSideA${aFinished > bFinished ? " tsLeading" : ""}`}>
        <span className="tsLabel">Team A</span>
        <span className="tsDots">
          {Array.from({ length: 8 }, (_, i) => (
            <span key={i} className={`tsDot${i < aFinished ? " tsDotA" : ""}`} />
          ))}
        </span>
        <span className="tsCount">{aFinished}</span>
      </div>

      <span className="tsVs">VS</span>

      <div className={`teamScoreSide teamSideB${bFinished > aFinished ? " tsLeading" : ""}`}>
        <span className="tsCount">{bFinished}</span>
        <span className="tsDots">
          {Array.from({ length: 8 }, (_, i) => (
            <span key={i} className={`tsDot${i < bFinished ? " tsDotB" : ""}`} />
          ))}
        </span>
        <span className="tsLabel">Team B</span>
      </div>
    </div>
  );
}
